import { IconWrapper } from '../runtime';
export default IconWrapper('task-list', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.8 7.78174L7 10L11.2688 5.69971M1.75 12.7498V3.24976C1.75 2.42133 2.42157 1.74976 3.25 1.74976H12.75C13.5784 1.74976 14.25 2.42133 14.25 3.24976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H3.25C2.42157 14.2498 1.75 13.5782 1.75 12.7498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});